import { Link } from "react-router-dom"
import per from '../../assets/images/per.png'

export default function Feedback(){
    return (
        <section className="feedback">
            <div className="title">Clients Feedback</div>
            <div className="feedbacks-wrapper">
                <div className="feedback">
                    <div className="feedback-writter">
                        <div className="profile-img" style={{backgroundImage: `url(${per})`}}></div>
                        <div className="name">Negar HB</div>
                    </div>
                    <div className="feedback-text">Exceptional service! Nasir Ahmad Ahamdy's web development expertise has transformed our vision into a stunning reality. His commitment to fast, responsive, and intuitive design is unparalleled. Woodlo</div>
                </div>
                <div className="feedback">
                    <div className="feedback-writter">
                        <div className="profile-img" style={{backgroundImage: `url(${per})`}}></div>
                        <div className="name">Rose</div>
                    </div>
                    <div className="feedback-text">Exceptional service! Nasir Ahmad Ahamdy's web development expertise has transformed our vision into a stunning reality. His commitment to fast, responsive, and intuitive design is unparalleled. Woodlo</div>
                </div>
                <div className="feedback">
                    <div className="feedback-writter">
                        <div className="profile-img" style={{backgroundImage: `url(${per})`}}></div>
                        <div className="name">Michael</div>
                    </div>
                    <div className="feedback-text">Exceptional service! Nasir Ahmad Ahamdy's web development expertise has transformed our vision into a stunning reality. His commitment to fast, responsive, and intuitive design is unparalleled. Woodlo</div>
                </div>
            </div>
            <div className="feed-buttons-wrapper">
                <div className="feed-control-btn active"></div>
                <div className="feed-control-btn"></div>
                <div className="feed-control-btn"></div>
            </div>
            <div className="comment-btn-wrapper">
                <Link className="btn-viewmore" to='/add-comment'>         
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M4 8H12"
                            stroke="white"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M8 12V4"
                            stroke="white"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    Add Your Comment
                </Link>
            </div>
        </section>
    )
}